export class MessageModel {
  _id?: any;
  uuid: string;
  conversation_uuid: string;
  session_thread_uuid: string;
  sender_property: SenderProperty;
  language_code: string
  timestamp: Date;
  channel: string
  revision?: string;
  status?: string;
  vrsn?: string;
  message_type: string;
  text: string;
  caption: string;
  message_media: MessageMedia;
  contact_card?: Contact;
  location?: Location;
  channel_payload: {};
  msg_payload: {};
  reply_to_msg: string;
  reply_to_endpoint: string;
  forwarded_from: string;
  context_msg_link: [];
  predefined_message_uuid?: string;
  buttons?: string[];
  predefined_message_name?: string;
  property_json?: any;
  external_msg_id?: string;

}

export class SenderProperty {
  sender_type: string;
  code: string;
  contact_agent_uuid: string;
  login_subject_uuid?: string;
  endpoint_uuid: string;
  reply?: boolean;
}

export class MessageMedia {
  bucket_name: string;
  bucket_key: string;
  file_size?: number;
  width?: number;
  height?: number;
  duration?: number;
  mime_type?: string;
  file_name?: string;
}

export class Location {
  latitude: number;
  longitude: number;
  address: string;
  title: string;
}

export class Contact {
  vcard: string;
}
